// Escopo GLOBAL dos jogos
import { i18n } from "../main";

export default {
  data() {
    return {
      placeholderData: "dd/mm/aaaa",
      idiomas: [
        { key: "Português", value: "pt" },
        { key: "Inglês", value: "en" },
        { key: "Espanhol", value: "es" },
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "",
          align: "center",
          sortable: false,
          value: "imagem",
        },
        {
          text: i18n.t("customers.name"),
          align: "center",
          sortable: true,
          value: "nome",
          width: 180,
        },
        {
          text: i18n.t("customers.email"),
          align: "center",
          sortable: true,
          value: "email",
          width: 180,
        },
        {
          text: i18n.t("customers.register-date"),
          align: "center",
          sortable: true,
          value: "ins_dthr",
          width: 180,
        },
        {
          text: `CPF/${i18n.t("customers.passport")}`,
          align: "center",
          sortable: true,
          value: "documento",
          width: 160,
        },
        {
          text: i18n.t("customers.state"),
          align: "center",
          sortable: true,
          value: "end_estado",
          width: 160,
        },
        {
          text: i18n.t("customers.city"),
          align: "center",
          sortable: true,
          value: "end_cidade",
          width: 160,
        },
        {
          text: i18n.t("customers.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
    },
    status() {
      return [
        { text: i18n.t("customers.active"), value: "ATIVO" },
        { text: i18n.t("customers.inactive"), value: "INATIVO" },
      ];
    },
    pessoa() {
      return [
        { text: i18n.t("customers.legal-person"), value: "JURIDICA" },
        { text: i18n.t("customers.natural-person"), value: "FISICA" },
      ];
    },
  },
  methods: {
    exportarConsumidores() {
      let csvHeader = "";
      let csvRows = "";
      let finalCsv = "";
      const processHeader = data => {
        let finalValue = "";
        for (var j = 0; j < data.length; j++) {
          if (
            data[j].text != "Ações" &&
            data[j].text != "Status" &&
            data[j].text != "Cidade" &&
            data[j].text != "Estado" &&
            data[j].text != ""
          ) {
            finalValue += data[j].text + ",";
          }
        }
        finalValue += "Tipo de Pessoa,Celular,País,Estado,Cidade,Status\n";

        return finalValue;
      };

      csvHeader = processHeader(this.headers);

      const processRow = data => {
        let rows = "";
        data.forEach(element => {
          if (element.tipo_pessoa == "JURIDICA") {
            rows +=
              element.razao_social +
              "," +
              element.email +
              "," +
              this.$config.convertDataBR(element.ins_dthr.substring(0, 10)) +
              "," +
              element.cnpj +
              "," +
              element.tipo_pessoa +
              "," +
              element.celular +
              "," +
              element.end_pais +
              "," +
              element.end_estado +
              "," +
              element.end_cidade +
              "," +
              element.status +
              "\n";
          } else {
            rows +=
              element.nome +
              "," +
              element.email +
              "," +
              this.$config.convertDataBR(element.ins_dthr.substring(0, 10)) +
              "," +
              element.documento +
              "," +
              element.tipo_pessoa +
              "," +
              element.celular +
              "," +
              element.end_pais +
              "," +
              element.end_estado +
              "," +
              element.end_cidade +
              "," +
              element.status +
              "\n";
          }
        });

        return rows;
      };

      if (this.exportar == "todos_consumidores") {
        csvRows = processRow(this.$loja_consumidor.consumidores);
      } else {
        if (this.$loja_consumidor.select_consumidores.length == 0) {
          this.$config.alert(
            "Selecione um consumidor para exportar",
            this.$config.dados.errorColor
          );
          return;
        }

        csvRows = processRow(this.$loja_consumidor.select_consumidores);
      }

      finalCsv = csvHeader + csvRows;

      var blob = new Blob([finalCsv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, "consumidores");
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", "consumidores");
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      this.closeModal();

      this.exportar = "todos_consumidores";
      this.$loja_consumidor.select_consumidores = [];
    },
    consumerTab(tab) {
      switch (tab.title) {
        case "Dados Cadastrais":
          document.getElementsByClassName(
            "pessoas-consumidor-dados-cadastrais"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "none";
          document.getElementsByClassName("endr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("endr")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "none";
          document.getElementsByClassName("empr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("empr")[0].style.color = "#000";
          break;

        case "Endereço":
          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "none";
          document.getElementsByClassName("empr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("empr")[0].style.color = "#000";
          break;

        case "Empresa":
          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-dados-cadastrais"
          )[0].style.display = "none";
          document.getElementsByClassName("dadosCad")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("dadosCad")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "none";
          document.getElementsByClassName("endr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("endr")[0].style.color = "#000";
          break;

        default:
          document.getElementsByClassName(
            "pessoas-agentes-dados-cadastrais"
          )[0].style.display = "block";
          document.getElementsByClassName(tab.class)[0].style.backgroundColor =
            "#393939";
          document.getElementsByClassName(tab.class)[0].style.color = "#fff";

          document.getElementsByClassName(
            "pessoas-consumidor-endereco"
          )[0].style.display = "none";
          document.getElementsByClassName("endr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("endr")[0].style.color = "#000";

          document.getElementsByClassName(
            "pessoas-consumidor-empresa"
          )[0].style.display = "none";
          document.getElementsByClassName("empr")[0].style.backgroundColor =
            "#c9c9c9";
          document.getElementsByClassName("empr")[0].style.color = "#000";
          break;
      }
    },
    goToConsumer(type, data) {
      this.$loja_consumidor.consumidorAddOrEdit = type;

      if (type === "editar") {
        this.$router.push({
          name: "consumersSettings",
          params: {
            type: "editar",
          },
        });
        // this.$axios.rota("/lojas/consumidor/editar");
        this.$loja_consumidor.cadastro.id_loja = data.idloja;
        this.$loja_consumidor.cadastro.dados_cadastrais.pessoa =
          data.tipo_pessoa;
        this.$loja_consumidor.cadastro.dados_cadastrais.id = data.idconsumidor;

        this.$loja_consumidor.cadastro.dados_cadastrais.email = data.email;
        this.$loja_consumidor.cadastro.dados_cadastrais.celular = data.celular;
        this.$loja_consumidor.cadastro.dados_cadastrais.idioma = data.idioma;
        this.$loja_consumidor.cadastro.dados_cadastrais.status = data.status;

        if (data.imagem) {
          this.$loja_consumidor.cadastro.dados_cadastrais.foto.imagem =
            data.imagem;
          this.$loja_consumidor.cadastro.dados_cadastrais.foto.have = true;
        }

        this.$loja_consumidor.cadastro.dados_cadastrais.pais = data.end_pais;
        this.$loja_consumidor.cadastro.dados_cadastrais.end_numero =
          data.end_numero;
        this.$loja_consumidor.cadastro.dados_cadastrais.complemento =
          data.end_complemento;
        this.$loja_consumidor.cadastro.dados_cadastrais.estado =
          data.end_estado;
        this.$loja_consumidor.cadastro.dados_cadastrais.cidade =
          data.end_cidade;
        this.$loja_consumidor.cadastro.dados_cadastrais.cep = data.end_cep;
        this.$loja_consumidor.cadastro.dados_cadastrais.bairro =
          data.end_bairro;
        this.$loja_consumidor.cadastro.dados_cadastrais.logradouro =
          data.end_logradouro;
        this.$loja_consumidor.cadastro.dados_cadastrais.permite_pacote =
          data.permite_pacote;
        this.$loja_consumidor.cadastro.dados_cadastrais.passaporte =
          data.passaporte;
        if (data.tipo_pessoa && data.tipo_pessoa == "JURIDICA") {
          this.$loja_consumidor.cadastro.dados_cadastrais.cnpj = data.cnpj;
          this.$loja_consumidor.cadastro.dados_cadastrais.razao_social =
            data.razao_social;
          return;
        }

        this.$loja_consumidor.cadastro.dados_cadastrais.nome = data.nome;
        this.$loja_consumidor.cadastro.dados_cadastrais.dt_nascimento =
          this.$config.convertDataBR(data.dt_nascimento);
        this.$loja_consumidor.cadastro.dados_cadastrais.documento =
          data.documento;
        return;
      }

      this.$router.push({
        name: "consumersSettings",
        params: {
          type: "cadastrar",
        },
      });
      // this.$axios.rota("/lojas/consumidor/cadastrar");
    },
  },
};
